import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ModalMain from "../../../components/modal";
import HeaderListFilter from "../../../components/header/report-filter";
import FiltroFiscal from "./filtro-fiscal";
import PainelDocumento from "./painel-documento";
import PainelNumero from "./painel-numero";
import DialogoJustificativa from "./dialogo-justificativa";

export default function PaginaFiscal({
	icone: Icone,
	titulo,
	subtitulo,
	consulta,
	camposFiltro,
	acoes,
	fonte,
	filtro: Filtro = FiltroFiscal,
	children,
}) {
	return (
		<div className="mt-14 flex flex-col h-[calc(100vh-6.5rem)] bg-gray-100 overflow-hidden">
			<ToastContainer />

			<div className="shrink-0 bg-white border-b px-6 py-4 flex items-start justify-between gap-4">
				<div className="flex items-center gap-3">
					<Icone size={22} className="text-customBlue-primary" />
					<div>
						<h1 className="text-lg font-semibold text-gray-800">{titulo}</h1>
						<p className="text-sm text-gray-500">{subtitulo}</p>
					</div>
				</div>

				<div className="flex items-start gap-4">
					<HeaderListFilter filterData={consulta.filtrosAplicados} />
					<button type="button" className="btn btn-sm btn-primary w-32" onClick={consulta.abrirFiltro}>
						Listar
					</button>
				</div>
			</div>

			<main className="flex-1 flex flex-col gap-4 overflow-y-auto min-h-0 p-6">{children}</main>

			<ModalMain ident={consulta.identFiltro}>
				<Filtro
					titulo={titulo}
					campos={camposFiltro}
					filtros={consulta.filtros}
					onFiltrar={consulta.filtrar}
				/>
			</ModalMain>

			<PainelDocumento
				painel={acoes.painel}
				fonte={fonte}
				onAba={acoes.trocarAba}
				onFechar={acoes.fecharPainel}
				onAcao={acoes.executar}
			/>

			<PainelNumero linha={acoes.numero} onFechar={acoes.fecharNumero} onAcao={acoes.executar} />

			{acoes.pedido && (
				<DialogoJustificativa pedido={acoes.pedido} onConfirmar={acoes.confirmar} onDesistir={acoes.desistir} />
			)}
		</div>
	);
}
